<!-- The speaker dialog on any page (useSpeakerDialog openSpeaker): the year's people sheet for
     the speaker's latest year (useSpeakerIndex) or a given year, shown with the year pages'
     dialog (Person/Highlight.vue). Without that year's sheet, it goes to /<year>/People#Name. -->
<template>
  <PersonHighlight
    v-if="records && personName"
    :key="`${personName}-${year}`"
    :person="personName"
    :people="records"
    :year="year"
    :keeps-address="keepsAddress"
    @hide="closeSpeaker" />
</template>

<script setup>
import {ref, watch} from "vue";
import {useRouter} from "vue-router";
import PersonHighlight from "@/components/People/Person/Highlight";
import {getPeopleRecords} from "@/components/People/peopleRecords";
import {fetchProgramSheet} from "@/composables/useProgramSheet";
import useSpeakerDialog from "@/composables/useSpeakerDialog";
import useSpeakerIndex, {getSpeakerKey} from "@/composables/useSpeakerIndex";

const router = useRouter();
const {speaker, closeSpeaker} = useSpeakerDialog();
const {index, getSpeaker} = useSpeakerIndex();

const records = ref(null);
const personName = ref("");
const year = ref(null);
const keepsAddress = ref(false);

async function fetchYearRecords(sheetYear) {
  try {
    return getPeopleRecords((await fetchProgramSheet(sheetYear)).speakers);
  } catch {
    return null;
  }
}

// the sheet's spelling of the name ("Seán" or "Sean")
function getRecordName(yearRecords, name) {
  const key = getSpeakerKey(name);
  return Object.keys(yearRecords || {}).find((recordName) => getSpeakerKey(recordName) === key);
}

function goToPeoplePage(name, sheetYear) {
  closeSpeaker();
  router.push(`/${sheetYear}/People#${name.replaceAll(" ", "_")}`);
}

async function showSpeaker(request) {
  records.value = null;
  if (!request) return;
  const sheetYear = request.year || getSpeaker(request.name)?.latestYear || request.fallbackYear;
  if (!sheetYear) return goToPeoplePage(request.name, new Date().getFullYear());
  const yearRecords = await fetchYearRecords(sheetYear);
  const recordName = getRecordName(yearRecords, request.name);
  if (!recordName) return goToPeoplePage(request.name, sheetYear);
  year.value = sheetYear;
  keepsAddress.value = Boolean(request.keepsAddress);
  personName.value = recordName;
  records.value = yearRecords;
}

// waits for the index when a speaker is opened before it has loaded
watch([speaker, index], ([request]) => {
  if (request && !request.year && !index.value) return;
  showSpeaker(request);
});
</script>
